export const logInfo = (message: string, _value?: unknown): void => {
  console.log(message);
};

export const logError = (message: string, _value?: unknown): void => {
  console.error(message);
};
